module.exports = __webpack_public_path__ + "img/logo.9c3f3358.png";